import { render } from "./MenuCategoriasComponent.vue?vue&type=template&id=445d64f5"
import script from "./MenuCategoriasComponent.vue?vue&type=script&lang=js"
export * from "./MenuCategoriasComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__